import script from "./NovelChapterList.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelChapterList.vue?vue&type=script&setup=true&lang=js"

import "./NovelChapterList.vue?vue&type=style&index=0&id=6f499d52&lang=css"

const __exports__ = script;

export default __exports__